var React = require('react');

function LandingAudio (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#00a4e6","d":"M0 45.5h6v17.8H0zM116.8 45.5h6v17.8h-6zM11.8 38.2h6v32.5h-6zM23.8 25.9h6v56.9h-6zM35.3 38.2h6v32.4h-6zM47 20.2h6v62.6h-6zM58.3 0h6v103.1h-6zM70.3 30.9h6v47h-6zM82.3 42.3h6v24.3h-6zM93.5 23.1h6v62.6h-6zM105.3 35.4h6v32.4h-6z","key":0}),React.createElement("path",{"fill":"#52cdff","d":"M0 51.4h6v6H0zM11.8 51.4h6v6h-6zM35.3 51.4h6v6h-6zM70.3 51.4h6v6h-6zM82.3 51.4h6v6h-6zM105.3 51.4h6v6h-6zM116.8 51.4h6v6h-6zM23.8 48.2h6v12.4h-6zM47 48.2h6v12.4h-6zM93.5 48.2h6v12.4h-6zM58.3 45.4h6v18h-6z","key":1})]);
}

LandingAudio.defaultProps = {"viewBox":"0 0 123 103"};

module.exports = LandingAudio;

LandingAudio.default = LandingAudio;
